module.exports = __webpack_public_path__ + "static/media/ball-shoe.8e28f3d9.svg";